'use strict';

var replaceEntities = require('../common/utils').replaceEntities;

module.exports = function normalizeLink(url) {
  var normalized = replaceEntities(url);
  // We shouldn't care about the result of malformed URIs,
  // and should not throw an exception.
  try {
    normalized = decodeURI(normalized);
  } catch (err) {}
  return encodeURI(normalized);
};



//////////////////
// WEBPACK FOOTER
// ./~/remarkable/lib/helpers/normalize_link.js
// module id = ZEe4
// module chunks = 0